import { render, staticRenderFns } from "./PriorityPulldown.vue?vue&type=template&id=43349172&"
import script from "./PriorityPulldown.vue?vue&type=script&lang=js&"
export * from "./PriorityPulldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports